export const environment = {
  production: true,
  useLocalConfig: false,
};
